const pub = { kind: 'public' };
const session = { kind: 'session' };
const svc = (...anyOf) => ({ kind: 'service', anyOf });
const r = (method, path, access, response, extra = {}) => ({ method, path, access, response, ...extra });
const json = { body: 'json' };
const jsonIdem = { body: 'json', idempotent: true };
export const API_ROUTES = {
    // Auth and branches (unified-access.md section 3)
    authLaunch: r('POST', '/auth/launch', pub, 'json', json),
    authMe: r('GET', '/auth/me', session, 'json'),
    authLogout: r('POST', '/auth/logout', pub, 'empty'),
    branches: r('GET', '/branches', session, 'json'),
    // Users and groups (as in Customers)
    usersList: r('GET', '/users', svc('USER_LIST'), 'json'),
    usersEmployeeLookup: r('GET', '/users/employee-lookup', svc('USER_CREATE'), 'json'),
    usersGet: r('GET', '/users/:id', svc('USER_VIEW'), 'json'),
    usersCreate: r('POST', '/users', svc('USER_CREATE'), 'json', json),
    usersUpdate: r('PATCH', '/users/:id', svc('USER_UPDATE'), 'json', json),
    usersChangeStatus: r('PUT', '/users/:id/status', svc('USER_CHANGE_STATUS'), 'json', json),
    usersResetPassword: r('POST', '/users/:id/reset-password', svc('USER_RESET_PASSWORD'), 'json'),
    usersDelete: r('DELETE', '/users/:id', svc('USER_DELETE'), 'json'),
    groupsList: r('GET', '/groups', svc('GROUP_LIST'), 'json'),
    servicesTree: r('GET', '/services', svc('GROUP_LIST'), 'json'),
    groupsGet: r('GET', '/groups/:id', svc('GROUP_VIEW'), 'json'),
    groupsCreate: r('POST', '/groups', svc('GROUP_CREATE'), 'json', json),
    groupsUpdate: r('PATCH', '/groups/:id', svc('GROUP_UPDATE'), 'json', json),
    groupsChangeStatus: r('PUT', '/groups/:id/status', svc('GROUP_CHANGE_STATUS'), 'json', json),
    groupsSetServices: r('PUT', '/groups/:id/services', svc('GROUP_SERVICE_MANAGE'), 'json', json),
    groupsDelete: r('DELETE', '/groups/:id', svc('GROUP_DELETE'), 'json'),
    // Commission tiers (section 3)
    tiersList: r('GET', '/tiers', svc('TIER_LIST'), 'json'),
    tiersGaps: r('GET', '/tiers/gaps', svc('TIER_LIST'), 'json'),
    tiersQuote: r('GET', '/tiers/quote', svc('TRANSFER_CREATE', 'TRANSFER_UPDATE', 'TIER_LIST'), 'json'),
    tiersGet: r('GET', '/tiers/:id', svc('TIER_VIEW'), 'json'),
    tiersCreate: r('POST', '/tiers', svc('TIER_CREATE'), 'json', json),
    tiersUpdate: r('PATCH', '/tiers/:id', svc('TIER_UPDATE'), 'json', json),
    tiersChangeStatus: r('PUT', '/tiers/:id/status', svc('TIER_CHANGE_STATUS'), 'json', json),
    tiersDelete: r('DELETE', '/tiers/:id', svc('TIER_DELETE'), 'empty'),
    // Boxes (section 6.1)
    boxesList: r('GET', '/boxes', svc('BOX_LIST', 'BALANCE_ADJUST', 'BALANCE_MOVE'), 'json'),
    boxesGet: r('GET', '/boxes/:id', svc('BOX_VIEW'), 'json'),
    boxesLedger: r('GET', '/boxes/:id/ledger', svc('BOX_VIEW'), 'json'),
    boxesLedgerExport: r('GET', '/boxes/:id/ledger/export', svc('BOX_VIEW'), 'file'),
    boxesCreate: r('POST', '/boxes', svc('BOX_CREATE'), 'json', json),
    boxesUpdate: r('PATCH', '/boxes/:id', svc('BOX_UPDATE'), 'json', json),
    boxesChangeStatus: r('PUT', '/boxes/:id/status', svc('BOX_CHANGE_STATUS'), 'json', json),
    boxesDelete: r('DELETE', '/boxes/:id', svc('BOX_DELETE'), 'empty'),
    // Bank accounts (section 6.2)
    bankAccountsList: r('GET', '/bank-accounts', svc('BANK_ACCOUNT_LIST', 'BALANCE_ADJUST', 'BALANCE_MOVE'), 'json'),
    bankAccountsGet: r('GET', '/bank-accounts/:id', svc('BANK_ACCOUNT_VIEW'), 'json'),
    bankAccountsLedger: r('GET', '/bank-accounts/:id/ledger', svc('BANK_ACCOUNT_VIEW'), 'json'),
    bankAccountsLedgerExport: r('GET', '/bank-accounts/:id/ledger/export', svc('BANK_ACCOUNT_VIEW'), 'file'),
    bankAccountsCreate: r('POST', '/bank-accounts', svc('BANK_ACCOUNT_CREATE'), 'json', json),
    bankAccountsUpdate: r('PATCH', '/bank-accounts/:id', svc('BANK_ACCOUNT_UPDATE'), 'json', json),
    bankAccountsChangeStatus: r('PUT', '/bank-accounts/:id/status', svc('BANK_ACCOUNT_CHANGE_STATUS'), 'json', json),
    bankAccountsDelete: r('DELETE', '/bank-accounts/:id', svc('BANK_ACCOUNT_DELETE'), 'empty'),
    // Balance movements (section 6.3)
    balanceAdjust: r('POST', '/balance-adjustments', svc('BALANCE_ADJUST'), 'json', jsonIdem),
    balanceMove: r('POST', '/balance-moves', svc('BALANCE_MOVE'), 'json', jsonIdem),
    // New transfer (section 4)
    transferFilterOptions: r('GET', '/transfer-options/filters', svc('TRANSFER_LIST', 'REPORT_VIEW', 'TRANSFER_UPDATE'), 'json'),
    transferOptions: r('GET', '/transfer-options', svc('TRANSFER_CREATE'), 'json'),
    duplicateReference: r('GET', '/transfers/duplicate-reference', svc('TRANSFER_CREATE', 'TRANSFER_UPDATE'), 'json'),
    draftsCreate: r('POST', '/transfers/drafts', svc('TRANSFER_CREATE'), 'json', json),
    draftsGet: r('GET', '/transfers/drafts/:id', svc('TRANSFER_CREATE'), 'json'),
    draftsUpdate: r('PATCH', '/transfers/drafts/:id', svc('TRANSFER_CREATE'), 'json', json),
    draftsUpdateParties: r('PATCH', '/transfers/drafts/:id/parties', svc('TRANSFER_CREATE'), 'json', json),
    draftsSend: r('POST', '/transfers/drafts/:id/send', svc('TRANSFER_CREATE'), 'json', json),
    draftsDiscard: r('POST', '/transfers/drafts/:id/discard', svc('TRANSFER_CREATE'), 'json'),
    draftsPost: r('POST', '/transfers/drafts/:id/post', svc('TRANSFER_CREATE'), 'json', jsonIdem),
    // Capture tasks through the shared tablet service (section 5)
    captureGet: r('GET', '/capture-tasks/:id', svc('TRANSFER_CREATE'), 'json'),
    captureResend: r('POST', '/capture-tasks/:id/resend', svc('TRANSFER_CREATE'), 'json', json),
    // Transfers list, details and actions (section 7)
    transfersList: r('GET', '/transfers', svc('TRANSFER_LIST'), 'json'),
    transfersTotals: r('GET', '/transfers/totals', svc('TRANSFER_LIST'), 'json'),
    transfersExport: r('GET', '/transfers/export', svc('TRANSFER_EXPORT'), 'file'),
    transfersGet: r('GET', '/transfers/:id', svc('TRANSFER_VIEW'), 'json'),
    transfersReceipt: r('GET', '/transfers/:id/receipt', svc('TRANSFER_CREATE', 'TRANSFER_REPRINT'), 'json'),
    transfersRecordPrint: r('POST', '/transfers/:id/prints', svc('TRANSFER_CREATE', 'TRANSFER_REPRINT'), 'json', json),
    transfersResendMessages: r('POST', '/transfers/:id/messages/resend', svc('TRANSFER_RESEND'), 'json', jsonIdem),
    transfersEditPreview: r('POST', '/transfers/:id/edit-preview', svc('TRANSFER_UPDATE'), 'json', json),
    transfersEdit: r('PATCH', '/transfers/:id', svc('TRANSFER_UPDATE'), 'json', jsonIdem),
    transfersCancel: r('POST', '/transfers/:id/cancel', svc('TRANSFER_CANCEL'), 'json', jsonIdem),
    // Private signature files (section 10)
    filesSignature: r('GET', '/files/signatures/:id', svc('TRANSFER_VIEW', 'TRANSFER_CREATE'), 'file'),
    // Tablets of the session branch, from the shared tablet service (section 5)
    tabletsOptions: r('GET', '/tablets/options', svc('TRANSFER_CREATE'), 'json'),
    // تأكيد رقم الهاتف through Customers (section 10, customers.md section 10.5)
    phoneVerificationsRequest: r('POST', '/phone-verifications', svc('TRANSFER_CREATE', 'TRANSFER_UPDATE'), 'json', jsonIdem),
    phoneVerificationsResend: r('POST', '/phone-verifications/:id/resend', svc('TRANSFER_CREATE', 'TRANSFER_UPDATE'), 'json', { idempotent: true }),
    phoneVerificationsVerify: r('POST', '/phone-verifications/:id/verify', svc('TRANSFER_CREATE', 'TRANSFER_UPDATE'), 'json', json),
    phoneVerificationsGet: r('GET', '/phone-verifications/:id', svc('TRANSFER_CREATE', 'TRANSFER_UPDATE'), 'json'),
    // Settings (section 10)
    settingsGet: r('GET', '/settings', svc('SETTINGS_VIEW'), 'json'),
    settingsUpdate: r('PATCH', '/settings', svc('SETTINGS_UPDATE'), 'json', json),
    // Reports (section 9)
    reportsDetailed: r('GET', '/reports/detailed', svc('REPORT_VIEW'), 'json'),
    reportsSummary: r('GET', '/reports/summary', svc('REPORT_VIEW'), 'json'),
    reportsByBranch: r('GET', '/reports/by-branch', svc('REPORT_VIEW'), 'json'),
    reportsByEmployee: r('GET', '/reports/by-employee', svc('REPORT_VIEW'), 'json'),
    reportsByCustomer: r('GET', '/reports/by-customer', svc('REPORT_VIEW'), 'json'),
    reportsHolders: r('GET', '/reports/holders', svc('REPORT_VIEW'), 'json'),
    reportsExport: r('GET', '/reports/:kind/export', svc('REPORT_EXPORT'), 'file'),
};
/** Replaces `:param` segments; values are URI-encoded. */
export function buildApiPath(path, params = {}) {
    return path.replace(/:([A-Za-z]+)/g, (_match, name) => {
        const value = params[name];
        if (value === undefined)
            throw new Error(`missing path parameter ${name}`);
        return encodeURIComponent(value);
    });
}
//# sourceMappingURL=routes.js.map